import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { Logger } from '@app/@shared/logger.service';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';

const log = new Logger('swipe-component');

@Component({
  selector: 'app-swipe',
  templateUrl: './swipe.component.html',
  styleUrl: './swipe.component.scss',
})
export class SwipeComponent implements OnInit, OnDestroy {
  @ViewChild('swiper') swiperEl!: ElementRef;

  @Output() reachedEnd = new EventEmitter<void>(); // Nuevo evento para detectar fin

  @Input() showButtons = false;
  @Input() showProgressBar = false;
  @Input() showProgressBullet = false;
  @Input() autoStart = false;
  @Input() loop = true;

  progress = 0;
  swiper?: Swiper;
  show = false;
  private autoSlideInterval: any;
  constructor() {}

  ngOnInit(): void {
    // Usar requestAnimationFrame para mejor rendimiento y menos delay
    requestAnimationFrame(() => {
      this.show = true;
      // Inicializar swiper después de que el DOM se actualice
      requestAnimationFrame(() => {
        this.initSwiper();
      });
    });
  }

  private clickCaptureListener = (event: MouseEvent) => {
    if (this.swiper && !(this.swiper as any).allowClick) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  };

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl.nativeElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: this.loop,
      allowTouchMove: true,
      preventClicks: true,
      preventClicksPropagation: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        progress: (swiper) => {
          this.progress = swiper.progress;
        },
        reachEnd: () => {
          this.reachedEnd.emit(); // Emitir evento cuando llega al final
        },
      },
    });

    // Evitar propagación en fase de captura para clicks fantasmas tras arrastrar
    this.swiperEl.nativeElement.addEventListener('click', this.clickCaptureListener, true);

    if (this.autoStart) {
      this.startAutoSlide();
    }
  }

  startAutoSlide() {
    this.autoSlideInterval = setInterval(() => {
      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.slideNext();
      }
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
    if (this.swiperEl && this.swiperEl.nativeElement) {
      this.swiperEl.nativeElement.removeEventListener('click', this.clickCaptureListener, true);
    }
  }

  ionViewDidEnter() {}

  ionViewDidLeave() {
    this.progress = 0;
    this.swiper?.slideTo(0);
  }

  next() {
    if (this.progress < 1) this.swiper?.slideNext();
  }

  prev() {
    this.swiper?.slidePrev();
  }
}
